export const TOKEN_COOKIE_NAME = 'token-cookie';
export const ANALYTICS_COOKIE_NAME = 'analytics-cookie';
